// hooks/useTabContext.js
import { useContext } from 'react';
import { TabContext } from '../context/tab-context';

/**
 * Hook to access the tab context
 * Provides both data and methods to update it
 * 
 * @returns {Object} Tab context with data and methods
 * 
 * @example
 * const { tabName, execution_date, brand, updateTabContext } = useTabContext();
 */
export const useTabContext = () => {
  const context = useContext(TabContext);
  
  if (context === null) {
    throw new Error('useTabContext must be used within TabContextProvider');
  }
  
  return context;
};